import { useParams, Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useUI } from '@/store/ui'
import { DaemonAPI } from '@/api/daemon'
import { Card } from '@diwata/ironvale'

export function RepoDetail() {
  const { name } = useParams<{ name: string }>()
  const { daemonUrl } = useUI()
  const api = new DaemonAPI(daemonUrl)

  const { data: brief, isLoading } = useQuery({
    queryKey: ['brief'],
    queryFn: () => api.getBrief(),
  })

  const repo = brief?.repos.find((r) => r.repo === name)

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <Link to="/" style={{ color: 'var(--ae-color-text-muted)', fontSize: 13, textDecoration: 'none' }}>
          ← Dashboard
        </Link>
      </div>

      {isLoading && <p className="ap-empty">Loading…</p>}

      {repo && (
        <>
          <div className="ap-page-header">
            <div>
              <div className="ap-page-title">{repo.repo}</div>
              <div className="ap-page-subtitle" style={{ fontFamily: 'monospace' }}>{repo.branch}</div>
            </div>
          </div>

          {repo.current_focus && (
            <Card style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ae-color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>Current Focus</div>
              <pre style={{ fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: 1.6, color: 'var(--ae-color-text-secondary)', fontFamily: 'inherit' }}>
                {repo.current_focus}
              </pre>
            </Card>
          )}

          {repo.active_task && (
            <Card style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ae-color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>Active Task</div>
              <pre style={{ fontSize: 13, whiteSpace: 'pre-wrap', lineHeight: 1.6, color: 'var(--ae-color-text-secondary)', fontFamily: 'inherit' }}>
                {repo.active_task}
              </pre>
            </Card>
          )}

          {repo.recent_commits.length > 0 && (
            <Card>
              <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ae-color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 10 }}>Recent Commits</div>
              {repo.recent_commits.map((c, i) => (
                <div key={i} className="ap-commit" style={{ padding: '4px 0', borderBottom: i < repo.recent_commits.length - 1 ? 'var(--ae-border-width) solid var(--ae-color-border)' : 'none' }}>
                  {c}
                </div>
              ))}
            </Card>
          )}
        </>
      )}

      {!isLoading && !repo && (
        <p className="ap-empty">Repo "{name}" not found in DAEMON's context.</p>
      )}
    </div>
  )
}
